import React, { useState } from 'react';
import { Tree } from "@minoru/react-dnd-treeview";
import { CustomDragPreview } from './CustomDragPreview';
import { CustomNode } from './CustomNode';
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { Placeholder } from "./Placeholder";
import styles from "./TreeViewComponent.module.css"


const TreeViewComponent = ({ treeData, handleDrop, visibleDelete, onDelete, onContextMenuClick, showEditMenu}) => {

    const [selectedNode, setSelectedNode] = useState(null);
    const handleSelect = (node) => {
        setSelectedNode(node)
    };

    const renderNode = (node, { depth, isOpen, onToggle }) => (
        <CustomNode
            node={node}
            depth={depth}
            isOpen={isOpen}
            isSelected={node.id === selectedNode?.id}
            onToggle={onToggle}
            onSelect={handleSelect}
            visibleDelete={visibleDelete}
            onDelete={onDelete}
            onContextMenuClick={onContextMenuClick}
            showEditMenu={showEditMenu}
        />
    );

    const renderDragPreview = (monitorProps) => (
        <CustomDragPreview monitorProps={monitorProps} />
    );

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Tree
                tree={treeData}
                rootId={0}
                render={renderNode}
                dragPreviewRender={renderDragPreview}
                onDrop={handleDrop}
                initialOpen={true}
                sort={false}
                dropTargetOffset={5}
                placeholderRender={(node, { depth }) => (
                    <Placeholder node={node} depth={depth} />
                )}
                insertDroppableFirst={false}
                canDrop={(tree, { dragSource, dropTargetId, dropTarget }) => {
                    if (dragSource?.parent === dropTargetId) {
                        return true;
                    }
                }}
                classes={{
                    placeholder: styles.placeholderContainer
                }}
            />
        </ThemeProvider>
    );
};

export default TreeViewComponent;
